/*
 * Focus Trap helpers
 */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

const trapFocusHandlers = {};

function trapFocus(container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = event => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  first.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args);
      t = true;
      setTimeout(() => (t = false), wait);
    }
  };
}

/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  Woolman.DetailsAccordions.init();

  if (theme.settings.enableWishlist) {
    Woolman.Wishlist.init();
  }

  // We need to add a global event listeners on card which are added after the DOM is ready
  const mutationConfig = { childList: true, subtree: true };

  const callback = function (mutationList) {
    for (const mutation of mutationList) {
      if (mutation.target.querySelectorAll('.card--product').length == 0) return;

      if (!mutation.target.dataset.mutated) {
        mutation.target.querySelectorAll('.card--product').forEach(function (card) {
          document.dispatchEvent(
            new CustomEvent('card:loaded', {
              detail: card,
            }),
          );

          card.dataset.mutated = true;
        });

        mutation.target.dataset.mutated = true;
      }
    }
  }.bind(this);

  const observer = new MutationObserver(callback);
  observer.observe(document.body, mutationConfig);

  // Attach theme editor listeners
  if (!Shopify || !Shopify.designMode) return;

  let lastSelection = {
    sectionId: undefined,
    blockId: undefined,
  };

  // Load is called when something is changed within section settings
  document.addEventListener('shopify:section:load', evt => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId;
    if (sectionId === Woolman.Header.cache.section.id) {
      Woolman.ModalsAndDrawers.init();
      Woolman.Header.init();
    }

    if (document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(
        document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id,
      );
    }

    console.log('shopify:section:load sectionId', evt.detail.sectionId);
    console.log('lastSelection', lastSelection);
  });

  document.addEventListener('shopify:block:select', evt => {
    const sectionId = 'shopify-section-' + evt.detail.sectionId;
    const blocks = document.getElementById(sectionId).querySelectorAll('[data-shopify-editor-block]');
    const selectedBlock = [...blocks].find(x => JSON.parse(x.dataset.shopifyEditorBlock).id === evt.detail.blockId);
    if (sectionId === Woolman.Header.cache.section.id) {
      if (selectedBlock) {
        // Make sure menu is open
        Woolman.Header.cache.openButton.click();

        // Select menu item
        const accordion = selectedBlock.closest('[data-accordion-item]').querySelector('input');
        const label = selectedBlock.closest('[data-accordion-item]').querySelector('label');
        if (!accordion.checked) label.click();
      }
    } else if (sectionId.includes('modal') && document.getElementById(sectionId).querySelector('[data-modal]')) {
      if (selectedBlock) {
        Woolman.ModalsAndDrawers.showModalOrDrawer(document.getElementById(sectionId).querySelector('[data-modal]').id);
      }
    }

    lastSelection.sectionId = evt.detail.sectionId;
    lastSelection.blockId = evt.detail.blockId;
    console.log('shopify:block:select', evt.detail.sectionId, evt.detail.blockId);
    console.log('lastSelection', lastSelection);
  });

  document.addEventListener('shopify:section:unload', evt => {
    console.log('shopify:section:unload sectionId', evt.detail.sectionId);
  });

  document.addEventListener('shopify:section:select', evt => {
    console.log('shopify:section:select', evt.detail.sectionId);
    lastSelection = {
      sectionId: evt.detail.sectionId,
      blockId: evt.detail.blockId,
    };

    if (
      evt.detail.sectionId.includes('modal') &&
      document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)
    ) {
      Woolman.ModalsAndDrawers.showModalOrDrawer(
        document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id,
      );
    }

    console.log('lastSelection', lastSelection);
  });

  document.addEventListener('shopify:section:deselect', evt => {
    console.log('shopify:section:deselect', evt.detail.sectionId);
    lastSelection = {
      sectionId: undefined,
      blockId: undefined,
    };

    if (
      evt.detail.sectionId.includes('modal') &&
      document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`)
    ) {
      Woolman.ModalsAndDrawers.closeModalOrDrawer(
        document.querySelector(`[data-modal][data-section-id="${evt.detail.sectionId}"]`).id,
      );
    }

    console.log('lastSelection', lastSelection);
  });
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  freeSampleType: 'free',
  paidSampleType: 'paid',
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};
    const paramsMap = {}; // Object to store parameters with the same key

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');

      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');

        if (keyValue.length) {
          const key = decodeURIComponent(keyValue[0]);
          const value = decodeURIComponent(keyValue[1]);

          // Check if the parameter key already exists
          if (paramsMap.hasOwnProperty(key)) {
            // Append the value to the existing key, separated by a comma
            paramsMap[key] += `,${value}`;
          } else {
            // Otherwise, create a new key-value pair
            paramsMap[key] = value;
          }
        }
      }
    }

    // Assign the combined parameters to Shopify.queryParams
    for (const [key, value] of Object.entries(paramsMap)) {
      Shopify.queryParams[key] = value;
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format, ignoreRate = false) {
    const default_money_format = theme.settings.moneyFormat || '€{{amount}}';

    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    if (window?.Shopify?.currency?.rate && ignoreRate !== true) {
      cents = cents * parseFloat(window.Shopify.currency.rate || 1.0);
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
  cartLimiter: async function (type) {
    const LIMITS = {
      free: theme.settings.samples.free,
      paid: theme.settings.samples.paid,
    };

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const cartData = await response.json();

      const samples = cartData.items.filter(item => item.properties['_sample'] === 'true');

      let sampleQuantity = 0;
      if (type === 'free') {
        sampleQuantity = samples
          .filter(item => item.properties['_sample_free'] === 'true')
          .reduce((total, item) => total + item.quantity, 0);
      } else if (type === 'paid') {
        sampleQuantity = samples
          .filter(item => item.properties['_sample_free'] !== 'true')
          .reduce((total, item) => total + item.quantity, 0);
      }

      if (sampleQuantity >= LIMITS[type]) {
        const modal = document.getElementById('samples-notification-modal');

        if (modal) {
          const modalTextElement = modal.querySelector('[data-modal-text]');
          modalTextElement.textContent = modalTextElement.textContent.replace(/{{\s*quantity\s*}}/g, LIMITS[type]);
          Woolman.ModalsAndDrawers.showModalOrDrawer('samples-notification-modal');
        }

        return false;
      }

      return true;
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return false;
    }
  },
  checkCart: async function () {
    try {
      const response = await fetch(`${routes.cart_url}.json`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const cartData = await response.json();

      const WIDTH_TRANSLATIONS = ['Width', 'Altezza'];
      const LENGTH_TRANSLATIONS = ['Length', 'Lunghezza'];
      const customRugs = cartData.items.filter(item => item.properties['_custom_rug'] === 'true');
      const linesToUpdate = [];

      for (const item of customRugs) {
        if (theme.settings.customizer.unitOfLength != item.properties['_unit_of_length']) {
          let properties = { ...item.properties };

          properties['_unit_of_length'] = theme.settings.customizer.unitOfLength;
          properties['_length'] = Woolman.Utils.convertLength(
            parseFloat(properties['_length']),
            item.properties['_unit_of_length'],
          );
          properties['_width'] = Woolman.Utils.convertLength(
            parseFloat(properties['_width']),
            item.properties['_unit_of_length'],
          );

          // Remove properties with translations from WIDTH_TRANSLATIONS and LENGTH_TRANSLATIONS
          for (const key in properties) {
            if (WIDTH_TRANSLATIONS.includes(key) || LENGTH_TRANSLATIONS.includes(key)) {
              delete properties[key];
            }
          }

          linesToUpdate.push({
            id: item.key,
            quantity: item.quantity,
            properties,
          });
        }
      }

      if (linesToUpdate.length > 0) {
        await Promise.all(
          linesToUpdate.map(({ id, quantity, properties }) =>
            debounce(Woolman.Utils.changeItem(id, quantity, properties), 200),
          ),
        );
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
      return false;
    }
  },

  changeItem: function (key, qty, properties = null) {
    return this._updateCart({
      url: `${window.routes.cart_change_url}.json?t=${Date.now()}`,
      data: {
        id: key,
        quantity: qty,
        ...(properties && { properties }),
      },
    });
  },

  changeItemByLine: function (line, qty, properties = null) {
    return this._updateCart({
      url: `${window.routes.cart_change_url}.json?t=${Date.now()}`,
      data: {
        line: line,
        quantity: qty,
        ...(properties && { properties }),
      },
    });
  },

  changeItems: function (updates) {
    return this._updateCart({
      url: `${window.routes.cart_update_url}.json?t=${Date.now()}`,
      data: {
        updates: updates,
      },
    });
  },

  _updateCart: function ({ url, data }) {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject(new Error(response.statusText));
        }
        return response.json();
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        throw error;
      });
  },

  convertLength: function (value, unit) {
    if (unit === 'inch') {
      // Convert inches to centimeters (1 inch = 2.54 cm)
      return value * 2.54;
    } else if (unit === 'cm') {
      // Convert centimeters to inches (1 cm = 0.393701 inches)
      return value / 2.54;
    } else {
      // Return an error message if the unit is not recognized
      return "Invalid unit. Please use 'inch' or 'cm'.";
    }
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'MainHeader',
    announcementBar: '.announcements-bar',
    cartBlip: '.cart-blip',
  },
  cache: {
    header: undefined,
    announcementBar: undefined,
    cartBlip: undefined,
    section: undefined,
    openButton: undefined,
  },

  init: function () {
    this.cache.header = document.getElementById(this.selectors.header);
    this.cache.announcementBar = document.querySelector(this.selectors.announcementBar);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);
    this.cache.section = this.cache.header.closest('.shopify-section');
    this.cache.openButton = this.cache.header.querySelector('[href="#drawer-menu"]');

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this));
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    document.documentElement.style.setProperty(
      '--header-height',
      `${(this.cache.header.clientHeight || 0) + (this.cache.announcementBar?.clientHeight || 0)}px`,
    );

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior);
  },

  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      behavior: behaviorType,
    };

    document.documentElement.classList.add('sticky-header-initialized', `sticky-header-${behaviorType}`);
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType === 'scroll' || behaviorType === 'fixed') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
       ** Find the direction of scroll
       ** 0 - initial, 1 - up, 2 - down
       */

      const toggleStickyHeader = (direction, curScroll) => {
        if (direction === 1 || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide');
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide');
        }

        prevDirection = direction;
      };

      window.addEventListener(
        'scroll',
        throttle(() => {
          curScroll = window.scrollY || document.documentElement.scrollTop;

          if (curScroll >= this.cache.header.clientHeight) {
            document.documentElement.classList.add('sticky-header-show');
          } else {
            document.documentElement.classList.remove('sticky-header-show');
          }

          if (curScroll > prevScroll) {
            direction = 2; // user scrolling down
          } else {
            direction = 1; // user scrolling up
          }

          if (direction !== prevDirection && behaviorType === 'scroll') {
            toggleStickyHeader(direction, curScroll);
          }

          prevScroll = curScroll;
        }, 50),
      );

      setInterval(() => {
        if (direction === 2 && behaviorType === 'scroll' && curScroll >= 900) {
          toggleStickyHeader(direction, curScroll);
        }
        if (window.scrollY === 0) {
          document.documentElement.classList.remove('sticky-header-show', 'sticky-header-hide');
          document.documentElement.style.setProperty(
            '--header-height',
            `${(this.cache.header.clientHeight || 0) + (this.cache.announcementBar?.clientHeight || 0)}px`,
          );
        }
      }, 200);
    }
  },

  async updateCartBlip(e) {
    const cart =
      (e.detail && e.detail.cart && e.detail.cart.item_count) ||
      (await (async function () {
        const res = await fetch('/cart.json');
        const cart = await res.json();
        return cart;
      })());

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
      this.cache.cartBlip.closest('.header-item__link').classList.remove('has-blip-visible');
    } else {
      this.cache.cartBlip.removeAttribute('hidden');
      this.cache.cartBlip.closest('.header-item__link').classList.add('has-blip-visible');
    }

    // Update notification cart amount at the same time (if present)
    const total_in_notification = document.querySelector('#cart-notification-link .cart-total');
    if (total_in_notification) {
      total_in_notification.textContent = cart.item_count;
    }
  },
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="#modal"]:not(.quick-buy__link)',
      drawerLink: 'a[href*="#drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    // Init open event listeners
    document.querySelectorAll(this.settings.selectors.modalLink).forEach(modalLink => {
      modalLink.addEventListener('click', event => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach(drawerLink => {
      drawerLink.addEventListener('click', event => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1).split('?')[0];
        const pageId = event.currentTarget.getAttribute('href').substring(1).split('?page=')[1];
        this.showModalOrDrawer(targetId, parseInt(pageId));
      });
    });

    // Init close event listeners
    const closeBtns = document.querySelectorAll('[data-close]');
    if (closeBtns) {
      closeBtns.forEach(closeBtn => {
        closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    const overlays = document.querySelectorAll('[data-overlay]');
    if (overlays) {
      overlays.forEach(overlay => {
        overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
      });
    }

    // Escape to close all
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        document.querySelectorAll('.drawer').forEach(drawer => {
          drawer.classList.remove('is-open');
        });
        document.querySelectorAll('.modal').forEach(modal => {
          modal.classList.remove('is-open');
        });
        document.body.classList.remove('overflow-hidden');
      }
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * @param {int} pageId - ID of page to load in modal or drawer, e.g. 1, 2, 3 (for multi-modal)
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function (targetId, pageId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    if (targetElement.classList.contains('is-open')) return;

    targetElement.classList.add('initialized', 'is-open');
    document.body.classList.add('overflow-hidden', 'modal-or-drawer-opened', `modal-or-drawer-opened-${targetId}`);
    const isMultiModal = targetElement.nodeName === 'MODAL-GRIDY-SLIDER-PARENT';

    if (targetId === 'drawer-search') {
      const inputElement = targetElement.querySelector('input[type="search"]');
      if (inputElement) {
        // iOS fix https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click/55652503#55652503
        const fakeInput = document.createElement('input');
        fakeInput.setAttribute('type', 'text');
        fakeInput.style.position = 'absolute';
        fakeInput.style.opacity = 0;
        fakeInput.style.height = 0;
        fakeInput.style.fontSize = '16px'; // disable auto zoom
        document.body.prepend(fakeInput);
        fakeInput.focus();

        setTimeout(() => {
          inputElement.focus();
          fakeInput.remove();
        }, 400);
      }
    } else {
      setTimeout(() => {
        trapFocus(targetElement);
      }, 600);
    }

    setTimeout(() => {
      // check targetElement node name to determine if it's a modal or drawer
      if (pageId && isMultiModal) {
        const gridySlider = targetElement.querySelector('gridy-slider');
        gridySlider.scrollToSlide(pageId - 1);
      }
    }, 600);
  },
  closeModalOrDrawer: function (targetId) {
    const targetElement = document.getElementById(targetId);
    targetElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden', 'modal-or-drawer-opened', `modal-or-drawer-opened-${targetId}`);
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    removeTrapFocus();
    const parentElement = event.currentTarget.closest('[data-parent]');
    parentElement.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden', 'modal-or-drawer-opened');

    const bodyClasses = document.body.classList;

    bodyClasses.forEach(className => {
      if (className.startsWith('modal-or-drawer-opened-')) {
        document.body.classList.remove(className);
      }
    });
  },
};

Woolman.Wishlist = {
  settings: {
    storageKey: 'Woolman_Wishlist',
    selectors: {
      trigger: '[data-wishlist-trigger]',
      wishlistBlip: '[data-wishlist-blip]',
    },
  },
  init: function () {
    const wishlist = localStorage.getItem(this.settings.storageKey)
      ? localStorage.getItem(this.settings.storageKey).split(',')
      : [];

    document.querySelectorAll(this.settings.selectors.trigger).forEach(
      function (wishlistTrigger) {
        if (wishlistTrigger && !wishlistTrigger.dataset.mutated) {
          if (wishlist.includes(wishlistTrigger.dataset.handle)) {
            wishlistTrigger.classList.add('active');
          }

          wishlistTrigger.addEventListener('click', event => {
            event.preventDefault();
            this.handleClick(event.currentTarget);
          });

          wishlistTrigger.dataset.mutated = true;
        }
      }.bind(this),
    );

    document.addEventListener('card:loaded', event => {
      event.detail.querySelectorAll(this.settings.selectors.trigger).forEach(
        function (wishlistTrigger) {
          if (wishlistTrigger && !wishlistTrigger.dataset.mutated) {
            if (wishlist.includes(wishlistTrigger.dataset.handle)) {
              wishlistTrigger.classList.add('active');
            }

            wishlistTrigger.addEventListener('click', event => {
              event.preventDefault();
              this.handleClick(event.currentTarget);
            });

            wishlistTrigger.dataset.mutated = true;
          }
        }.bind(this),
      );
    });

    this.updateWishlistBlip();
  },

  updateWishlistBlip: function () {
    const wishlist = localStorage.getItem(this.settings.storageKey)
      ? localStorage.getItem(this.settings.storageKey).split(',')
      : [];
    const wishlistBlips = document.querySelectorAll(this.settings.selectors.wishlistBlip);

    wishlistBlips.forEach(wishlistBlip => {
      wishlistBlip.textContent = wishlist.length;

      if (wishlist.length == 0) {
        wishlistBlip.setAttribute('hidden', true);
        wishlistBlip.closest('.header-item__link')?.classList.remove('has-blip-visible');
      } else {
        wishlistBlip.removeAttribute('hidden');
        wishlistBlip.closest('.header-item__link')?.classList.add('has-blip-visible');
      }
    });
  },

  handleClick: function (wishlistTrigger) {
    const productHandle = wishlistTrigger.dataset.handle;
    let wishlist = localStorage.getItem(this.settings.storageKey)
      ? localStorage.getItem(this.settings.storageKey).split(',')
      : [];

    if (wishlist.includes(productHandle)) {
      this.remove(productHandle);
    } else {
      this.add(productHandle);
    }

    document.querySelectorAll(`${this.settings.selectors.trigger}[data-handle="${productHandle}"]`).forEach(el => {
      el.classList.toggle('active');
    });
  },

  add: function (productHandle) {
    const wishlist = localStorage.getItem(this.settings.storageKey)
      ? localStorage.getItem(this.settings.storageKey).split(',')
      : [];
    wishlist.unshift(productHandle);
    localStorage.setItem(this.settings.storageKey, wishlist.join(','));

    const event = new CustomEvent('wishlist:add', {
      detail: productHandle,
    });

    document.dispatchEvent(event);
    this.updateWishlistBlip();
  },

  remove: function (productHandle) {
    let wishlist = localStorage.getItem(this.settings.storageKey)
      ? localStorage.getItem(this.settings.storageKey).split(',')
      : [];
    wishlist = wishlist.filter(e => e !== productHandle);
    localStorage.setItem(this.settings.storageKey, wishlist.join(','));

    const event = new CustomEvent('wishlist:remove', {
      detail: productHandle,
    });

    document.dispatchEvent(event);
    this.updateWishlistBlip();
  },
};

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250,
);

/**
 * Animated details element
 */
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', e => this.onClick(e));
    this.toggleByViewport();
    document.addEventListener('woolman:resize', this.toggleByViewport.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-in-out',
      },
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      },
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }

  toggleByViewport() {
    let mobileClose = this.el.dataset.mobileClose != undefined ? JSON.parse(this.el.dataset.mobileClose) : false;
    let desktopOpen = this.el.dataset.desktopOpen != undefined ? JSON.parse(this.el.dataset.desktopOpen) : false;

    if (woolman_window_size >= 768 && desktopOpen) {
      this.el.open = true;
    } else if (mobileClose) {
      this.el.open = false;
    }
  }
}

Woolman.DetailsAccordions = {
  init: function () {
    document.querySelectorAll('details').forEach(el => {
      new Accordion(el);
    });
  },
};

Woolman.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
    };

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

// Custom element that enhances HTML Video Element functionality.
// Usage: <video is="superpowered-video">
class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    this.container = this.closest('.video-container') || null;

    if (this.container) this.attachClickListener(this.closest('.video-container'));

    // check if video is iframe and has a src and that src is youtube
    if (this.video.nodeName === 'IFRAME' && this.video.src && this.video.src.includes('youtube') && !this.container) {
      this.video.addEventListener('load', this.onVideoLoad.bind(this));
    }

    // When video is out of viewport pause it. This is to prevent videos from playing in the background.
    // If video is in viewport play it.
    // Use: Intersection Observer API
    const autoplay = this.dataset.autoplay || false;
    if (!autoplay || this.container) return;

    const videoType = this.video.nodeName === 'VIDEO' ? 'video' : 'iframe';
    const videoHost =
      this.video.nodeName === 'VIDEO' ? 'shopify' : this.video.src.includes('youtube') ? 'youtube' : 'vimeo';

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (videoType == 'video') {
              this.video.play();
            } else if (videoHost == 'youtube') {
              this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (videoHost == 'vimeo') {
              this.video.contentWindow.postMessage('{"method":"play"}', '*');
            }
          } else {
            if (videoType == 'video') {
              this.video.pause();
            } else if (videoHost == 'youtube') {
              this.video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            } else if (videoHost == 'vimeo') {
              this.video.contentWindow.postMessage('{"method":"pause"}', '*');
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    observer.observe(this.video);
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', e => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    };

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    };
  }

  onVideoLoad() {
    // force youtube to play on mobile
    this.video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  }
}
customElements.define('superpowered-video', SuperPoweredVideo);

// Gridy Slider - a custom Woolman built slider.
// Usage: <gridy-slider>
class GridySlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.track = this.querySelector('.gridy-track');
    this.slides = this.querySelectorAll('.gridy-track > *');

    this.arrows = this.querySelector('.gridy-arrows');

    const data_ipr_desktop = parseInt(this.dataset.iprDesktop, 10) || 1;
    const data_ipr_tablet = parseInt(this.dataset.iprTablet, 10) || data_ipr_desktop;
    const data_ipr_mobile = parseInt(this.dataset.iprMobile, 10) || 1;
    const data_init_scroll_to = this.dataset.initScrollTo;
    const data_autoplay = this.dataset.autoplay != undefined ? JSON.parse(this.dataset.autoplay) : false;
    const data_autoplay_delay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
    const data_is_thumbnails_slider = this.dataset.thumbnailsFor != undefined ? true : false;
    const data_indicator = this.dataset.indicator != undefined ? JSON.parse(this.dataset.indicator) : false;
    const data_sliding_behavior = this.dataset.slidingBehavior;
    const data_thumbnail_slider = document.getElementById(`thumbnail-${this.id}`);
    const data_track_overflow_visible = this.dataset.overflowVisible != undefined ? true : false;
    const data_card_type = this.dataset.cardType != undefined ? this.dataset.cardType : false;

    this.config = {
      slide_count: this.slides.length,
      current_slide: 0,
      active_slide_offset: 0,

      ipr_desktop: data_ipr_desktop,
      ipr_tablet: data_ipr_tablet,
      ipr_mobile: data_ipr_mobile,
      breakpoint_tablet: 768,
      breakpoint_desktop: 1024,

      arrows: true,
      autoplay: data_autoplay || false,
      autoplay_delay: data_autoplay_delay,
      timer: null,

      is_thumbnails_slider: data_is_thumbnails_slider,
      thumbnails_for: undefined,
      thumbnail_slider: data_thumbnail_slider,

      indicator: data_indicator,
      track_overflow_visible: data_track_overflow_visible,
      sliding_behavior: data_sliding_behavior || 'all',
    };

    if (data_init_scroll_to != undefined) {
      this.scrollToSlideByID(data_init_scroll_to);
    }

    if (this.config.arrows) {
      this.buttons = this.querySelectorAll('[data-gridy-arrow]');
      this.handleArrowClick = this.onArrowClick.bind(this);

      this.buttons.forEach(arrowButton => {
        arrowButton.addEventListener('click', this.handleArrowClick);
      });
    }

    if (this.config.autoplay) {
      this.autoplayGridy();
      this.addEventListener('mouseenter', this.clearAutoplayTimer);
      this.addEventListener('mouseleave', this.autoplayGridy);
      this.addEventListener('touchenter', this.clearAutoplayTimer);
      this.addEventListener('touchleave', this.autoplayGridy);
    }

    if (this.config.is_thumbnails_slider) {
      this.config.active_slide_offset = 2;
      this.config.thumbnails_for = document.getElementById(this.dataset.thumbnailsFor);
      this.thumbnail = this.querySelectorAll('[data-thumbnail-btn]');
      this.thumbnail.forEach(thumbnail => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    if (this.config.indicator) {
      this.indicator_dots = this.querySelectorAll('[data-indicator-dot]');
      this.indicator_current = this.querySelector('[data-indicator-current]');
    }

    if (!this.config.is_thumbnails_slider) {
      let scrollTimeout;
      this.track.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.afterScrollStops.bind(this), 200);
      });
    }

    if (data_card_type && data_card_type == 'traditional') {
      window.addEventListener('resize', this.adjustArrowsPosition.bind(this));
      this.adjustArrowsPosition();
    }
  }

  reset(scrollToFirstSlide = true) {
    if (this.config.autoplay && this.config.timer) {
      this.clearAutoplayTimer();
    }

    this.removeEventListener('mouseenter', this.clearAutoplayTimer);
    this.removeEventListener('mouseleave', this.autoplayGridy);
    this.removeEventListener('touchenter', this.clearAutoplayTimer);
    this.removeEventListener('touchleave', this.autoplayGridy);
    this.track.removeEventListener('scroll', this.afterScrollStops);

    if (this.config.arrows) {
      this.buttons.forEach(arrowButton => {
        arrowButton.removeEventListener('click', this.handleArrowClick);
      });
    }

    scrollToFirstSlide && this.scrollToSlide(0);

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.track = null;
    this.slides = null;
    this.buttons = null;
    this.thumbnail = null;
    this.indicator_dots = null;
    this.indicator_current = null;

    this.init();
  }

  afterScrollStops() {
    let slideInView = this.firstSlideInView();
    this.config.current_slide = slideInView;
    this.setActiveSlide(this.slides[slideInView + this.config.active_slide_offset]);

    if (this.config.thumbnail_slider) {
      this.config.thumbnail_slider.scrollToSlide(slideInView);
    }
  }

  autoplayGridy() {
    this.config.timer = setInterval(this.scrollByIPR.bind(this), this.config.autoplay_delay, 'next');
  }

  clearAutoplayTimer() {
    clearInterval(this.config.timer);
    this.config.timer = null;
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.config.current_slide = Array.from(event.currentTarget.parentNode.children).indexOf(event.currentTarget);
    this.config.thumbnails_for.scrollToSlideByID(event.currentTarget.dataset.itemId);
    this.scrollToSlide(this.config.current_slide);
  }

  onArrowClick(event) {
    this.scrollByIPR(event.currentTarget.dataset.direction);
  }

  scrollByIPR(direction) {
    let currentIPR = this.getCurrentIPR(),
      slideMultiplier = this.config.sliding_behavior == 'all' ? currentIPR : 1,
      newCurrentSlide = this.config.current_slide,
      lastToShow = this.config.slide_count - currentIPR;

    /* 
      Used to check the next visible slide. If the next slide is not visible, it will skip to the next visible slide.
      This is used on PDP where we render all the images, but show only the images of the selected variant.
    */

    const isSlideVisible = index => {
      const slide = this.slides[index];
      return slide && window.getComputedStyle(slide).display !== 'none';
    };

    if (direction === 'next') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide++;
        if (newCurrentSlide > lastToShow) {
          //newCurrentSlide = 0;
          return; // stop at the end
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide++;
          if (newCurrentSlide > lastToShow) {
            newCurrentSlide = 0;
          }
        }
      }
    } else if (direction === 'prev') {
      for (let i = 0; i < slideMultiplier; i++) {
        newCurrentSlide--;
        if (newCurrentSlide < 0) {
          //newCurrentSlide = lastToShow;
          return; // stop at the beginning
        }
        while (!isSlideVisible(newCurrentSlide)) {
          newCurrentSlide--;
          if (newCurrentSlide < 0) {
            newCurrentSlide = lastToShow;
          }
        }
      }
    }
    this.config.current_slide = newCurrentSlide;
    this.scrollToSlide(newCurrentSlide);
  }

  scrollToSlide(newPosition) {
    if (isNaN(newPosition)) {
      return;
    }

    let slidePosWithOffset = newPosition - this.config.active_slide_offset,
      newScrollToSlidePos = slidePosWithOffset > 0 ? slidePosWithOffset : 0;

    const slideInNewScrollToPos = this.slides[newScrollToSlidePos];

    if (!slideInNewScrollToPos) return;

    let scrollToLeft = slideInNewScrollToPos.offsetLeft,
      scrollToTop = slideInNewScrollToPos.offsetTop;

    if (this.config.track_overflow_visible) {
      scrollToLeft = this.slides[newScrollToSlidePos].offsetLeft - this.slides[0].offsetLeft;
    }

    this.track.scrollTo({
      left: scrollToLeft,
      top: scrollToTop,
      behavior: 'smooth',
    });

    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    this.slides[newPosition].classList.add('active');

    this.config.current_slide = newPosition;
    this.setActiveSlide(this.slides[newPosition]);
  }

  scrollToSlideByID(slideID) {
    const theSlide = document.getElementById(slideID),
      newPosition = Array.from(theSlide.parentNode.children).indexOf(theSlide);
    this.scrollToSlide(newPosition);
  }

  setActiveSlide(slide) {
    this.slides.forEach(item => {
      item.classList.remove('active');
    });

    slide.classList.add('active');

    if (this.config.indicator) {
      if (this.indicator_current) {
        this.indicator_current.textContent = this.config.current_slide + 1;
      }

      if (this.indicator_dots) {
        this.indicator_dots.forEach(dot => {
          dot.classList.remove('active');
        });

        if (this.indicator_dots[this.config.current_slide]) {
          this.indicator_dots[this.config.current_slide].classList.add('active');
        }
      }
    }
  }

  getCurrentIPR() {
    let currentIPR = this.config.ipr_mobile;
    if (woolman_window_size >= this.config.breakpoint_desktop) {
      currentIPR = this.config.ipr_desktop;
    } else if (woolman_window_size >= this.config.breakpoint_tablet) {
      currentIPR = this.config.ipr_tablet;
    }
    return currentIPR;
  }

  firstSlideInView() {
    let loopIndex = 0;
    for (const slide of this.slides) {
      if (this.isSlideInView(slide)) {
        return loopIndex;
      }
      ++loopIndex;
    }
    return this.config.current_slide;
  }

  isSlideInView(slide) {
    const containerBounds = this.track.getBoundingClientRect();
    const slideBounds = slide.getBoundingClientRect();

    const isSlideVisible =
      Math.round(slideBounds.top) >= Math.floor(containerBounds.top) &&
      Math.floor(slideBounds.bottom) <= Math.round(containerBounds.bottom) &&
      Math.round(slideBounds.left) >= Math.floor(containerBounds.left) &&
      Math.floor(slideBounds.right) <= Math.round(containerBounds.right) &&
      window.getComputedStyle(slide).display !== 'none';

    return isSlideVisible;
  }

  adjustArrowsPosition() {
    const firstMediaItem = this.querySelector('.card-media');

    if (!firstMediaItem) return;

    const height = firstMediaItem.offsetHeight;

    this.arrows.style.top = `${height / 2}px`;
  }
}

customElements.define('gridy-slider', GridySlider);

// QuantityInput for + and - button functionality
// Used in: cart items, upsell items
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // Update the input value based on the button clicked
    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    // Check if the value has changed and dispatch the change event if necessary
    if (previousValue !== this.input.value) {
      const changeEvent = new Event('change', {
        bubbles: true,
        cancelable: true,
      });
      changeEvent.previousValue = previousValue;
      changeEvent.operation = event.target.name;
      this.input.dispatchEvent(changeEvent);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

class CustomSizeForm extends HTMLElement {
  constructor() {
    super();

    const productMain = this.closest('.product-main');
    const productModal = this.closest('.product-modal');

    this.form =
      (productMain && productMain.querySelector('product-form form')) ||
      (productModal && productModal.querySelector('product-form form'));

    if (!this.form) return;

    this.initializeAttributes();
    this.initializeElements();
    this.initializeDimensions();

    this.cloneButtonAdded = false;
    this.isDropdownOpen = false;
    this.hasError = false; // Flag to track if there is an error

    this.bindMethods();
    this.addEventListeners();
    this.updateButtonState();
  }

  initializeAttributes() {
    this.unitPrice = parseFloat(this.getAttribute('unit-price')) || 0;
    this.basePrice = parseFloat(this.getAttribute('base-price')) || 0;
    this.unitOfLength = this.getAttribute('unit-of-length');
  }

  initializeElements() {
    this.priceDisplay = this.querySelector('[data-price-placeholder]');
    this.addToCartButtonContainer = this.querySelector('[data-button-placeholder]');
    this.addToCartButton = this.form.querySelector('button[type="submit"]');
    this.parentDropdown = this.closest('custom-dropdown');
  }

  initializeDimensions() {
    if (this.unitOfLength === 'inch') {
      this.initializeFeetInchElements();
    } else {
      this.initializeMetricElements();
    }
  }

  initializeMetricElements() {
    this.widthInput = this.querySelector('input[name="customWidth"]');
    this.lengthInput = this.querySelector('input[name="customLength"]');

    this.initialMinWidth = parseFloat(this.widthInput.min);
    this.initialMaxWidth = parseFloat(this.widthInput.max);
    this.initialMinLength = parseFloat(this.lengthInput.min);
    this.initialMaxLength = parseFloat(this.lengthInput.max);
  }

  initializeFeetInchElements() {
    this.widthFeetInput = this.querySelector('input[name="customWidthFeet"]');
    this.widthInchesInput = this.querySelector('input[name="customWidthInches"]');
    this.lengthFeetInput = this.querySelector('input[name="customLengthFeet"]');
    this.lengthInchesInput = this.querySelector('input[name="customLengthInches"]');

    this.initialMinWidth = parseFloat(this.widthFeetInput.getAttribute('data-min-inches'));
    this.initialMaxWidth = parseFloat(this.widthFeetInput.getAttribute('data-max-inches'));
    this.initialMinLength = parseFloat(this.lengthFeetInput.getAttribute('data-min-inches'));
    this.initialMaxLength = parseFloat(this.lengthFeetInput.getAttribute('data-max-inches'));
  }

  bindMethods() {
    this.onCustomDropdownChange = this.onCustomDropdownChange.bind(this);
    this.onCustomDropdownClose = this.onCustomDropdownClose.bind(this);
    this.onCloneButtonClick = this.onCloneButtonClick.bind(this);
    this.onDimensionInputChange = this.onDimensionInputChange.bind(this);
    this.validateAndCorrectRange = this.validateAndCorrectRange.bind(this);
    this.updateButtonState = this.updateButtonState.bind(this);
  }

  addEventListeners() {
    document.addEventListener('custom-dropdown--variant-picker:change', this.onCustomDropdownChange);
    document.addEventListener('custom-dropdown--variant-picker:close', this.onCustomDropdownClose);

    if (this.unitOfLength === 'inch') {
      this.addFeetInchEventListeners();
    } else {
      this.addMetricEventListeners();
    }
  }

  addFeetInchEventListeners() {
    this.widthFeetInput.addEventListener('blur', this.validateAndCorrectRange);
    this.widthFeetInput.addEventListener('change', this.validateAndCorrectRange);
    this.widthInchesInput.addEventListener('blur', this.validateAndCorrectRange);
    this.widthInchesInput.addEventListener('change', this.validateAndCorrectRange);
    this.lengthFeetInput.addEventListener('blur', this.validateAndCorrectRange);
    this.lengthFeetInput.addEventListener('change', this.validateAndCorrectRange);
    this.lengthInchesInput.addEventListener('blur', this.validateAndCorrectRange);
    this.lengthInchesInput.addEventListener('change', this.validateAndCorrectRange);
  }

  addMetricEventListeners() {
    this.widthInput.addEventListener('blur', this.validateAndCorrectRange);
    this.widthInput.addEventListener('change', this.validateAndCorrectRange);
    this.lengthInput.addEventListener('blur', this.validateAndCorrectRange);
    this.lengthInput.addEventListener('change', this.validateAndCorrectRange);
  }

  onCustomDropdownChange(event) {
    const selectedOption = event.detail?.option;

    if (selectedOption?.hasAttribute('data-is-custom-size-variant')) {
      this.classList.add('active');
      this.isDropdownOpen = true;
      this.updatePrice();

      // Hide the dropdown items when form is active
      if (this.parentDropdown && this.parentDropdown.itemsContainer) {
        this.parentDropdown.itemsContainer.style.display = 'none';
      }

      if (!this.parentDropdown.classList.contains('opened')) {
        this.parentDropdown.toggleDropdown();
      }

      if (!this.cloneButtonAdded) {
        this.addCloneButton();
      }
    }
  }

  addCloneButton() {
    this.clonedButton = this.addToCartButton.cloneNode(true);
    this.addToCartButtonContainer.appendChild(this.clonedButton);
    this.clonedButton.addEventListener('click', this.onCloneButtonClick);
    this.cloneButtonAdded = true;
    this.updateButtonState();
  }

  onCloneButtonClick() {
    if (this.unitOfLength === 'inch') {
      const lengthInches = `${this.lengthFeetInput.value} ft ${this.lengthInchesInput.value || 0} in`;
      const widthInches = `${this.widthFeetInput.value} ft ${this.widthInchesInput.value || 0} in`;

      this.addInputToForm(window.customizerStrings['length'].cartPropertyLabel, lengthInches);
      this.addInputToForm(window.customizerStrings['width'].cartPropertyLabel, widthInches);
      this.addInputToForm('_width_feet', `${this.widthFeetInput.value}`);
      this.addInputToForm('_width_inches', `${this.widthInchesInput.value || 0}`);
      this.addInputToForm('_length_feet', `${this.lengthFeetInput.value}`);
      this.addInputToForm('_length_inches', `${this.lengthInchesInput.value || 0}`);

      // Convert feet and inches to centimeters
      const totalWidthInInches =
        (parseFloat(this.widthFeetInput.value) || 0) * 12 + (parseFloat(this.widthInchesInput.value) || 0);
      const totalLengthInInches =
        (parseFloat(this.lengthFeetInput.value) || 0) * 12 + (parseFloat(this.lengthInchesInput.value) || 0);
      const widthInCm = Math.round(totalWidthInInches * 2.54);
      const lengthInCm = Math.round(totalLengthInInches * 2.54);

      this.addInputToForm('_width_cm', `${widthInCm}`);
      this.addInputToForm('_length_cm', `${lengthInCm}`);
    } else {
      this.addInputToForm(window.customizerStrings['length'].cartPropertyLabel, `${this.lengthInput.value} cm`);
      this.addInputToForm(window.customizerStrings['width'].cartPropertyLabel, `${this.widthInput.value} cm`);

      this.addInputToForm('_width_cm', `${this.widthInput.value}`);
      this.addInputToForm('_length_cm', `${this.lengthInput.value}`);
    }

    this.addInputToForm('_custom_rug', true);
    this.addInputToForm('_unit_of_length', this.unitOfLength);

    const clickEvent = new MouseEvent('click', {
      bubbles: false,
      cancelable: true,
      view: window,
    });

    this.addToCartButton.dispatchEvent(clickEvent);
      this.classList.remove('active');
  if (this.parentDropdown && this.parentDropdown.itemsContainer) {
    this.parentDropdown.itemsContainer.style.display = '';
  }
  }

  addInputToForm(name, value, type = 'hidden') {
    const inputElement = document.createElement('input');
    inputElement.type = type;
    inputElement.name = `properties[${name}]`;
    inputElement.value = value || '';
    inputElement.classList.add('customizer-input');
    this.form.appendChild(inputElement);
  }

  onDimensionInputChange(event) {
    this.validateAndCorrectRange(event);
    this.updateButtonState();
    this.updatePrice();
  }

  validateAndCorrectRange(event) {
    const input = event.target;
    let value = parseFloat(input.value);
    this.hasError = false; // Reset error flag

    if (this.unitOfLength === 'inch') {
      this.hasError = this.validateFeetInches(input, value);
    } else {
      this.hasError = this.validateMetric(input, value);
    }

    this.updateButtonState();
    this.updatePrice();
  }

  validateFeetInches(input, value) {
    let errorOccurred = false;

    // Ensure the value is an integer
    if (!Number.isInteger(value)) {
      value = Math.floor(value); // Round down to the nearest integer
      input.value = value; // Update the input field with the rounded value
    }

    // Validate Feet and Inches for Width
    if (input.name === 'customWidthFeet') {
      if (value < parseFloat(this.widthFeetInput.min) || value > parseFloat(this.widthFeetInput.max)) {
        errorOccurred = true;
      }
      // Clamp the value after checking for errors
      value = Math.max(parseFloat(this.widthFeetInput.min), Math.min(value, parseFloat(this.widthFeetInput.max)));
      this.widthFeetInput.value = value;

      // Update the maximum inches based on the new feet value
      const maxInchesWidth = Math.max(0, this.initialMaxWidth - value * 12);
      this.widthInchesInput.max = Math.min(maxInchesWidth, 11);

      // Reset inches if they exceed the new max
      if (parseFloat(this.widthInchesInput.value) > this.widthInchesInput.max) {
        this.widthInchesInput.value = this.widthInchesInput.max;
      }
    } else if (input.name === 'customWidthInches') {
      if (value < parseFloat(this.widthInchesInput.min) || value > parseFloat(this.widthInchesInput.max)) {
        errorOccurred = true;
      }
      // Clamp the value after checking for errors
      value = Math.max(parseFloat(this.widthInchesInput.min), Math.min(value, parseFloat(this.widthInchesInput.max)));
      this.widthInchesInput.value = value;
    }

    // Validate Feet and Inches for Length
    if (input.name === 'customLengthFeet') {
      if (value < parseFloat(this.lengthFeetInput.min) || value > parseFloat(this.lengthFeetInput.max)) {
        errorOccurred = true;
      }
      // Clamp the value after checking for errors
      value = Math.max(parseFloat(this.lengthFeetInput.min), Math.min(value, parseFloat(this.lengthFeetInput.max)));
      this.lengthFeetInput.value = value;

      // Update the maximum inches based on the new feet value
      const maxInchesLength = Math.max(0, this.initialMaxLength - value * 12);
      this.lengthInchesInput.max = Math.min(maxInchesLength, 11);

      // Reset inches if they exceed the new max
      if (parseFloat(this.lengthInchesInput.value) > this.lengthInchesInput.max) {
        this.lengthInchesInput.value = this.lengthInchesInput.max;
      }
    } else if (input.name === 'customLengthInches') {
      if (value < parseFloat(this.lengthInchesInput.min) || value > parseFloat(this.lengthInchesInput.max)) {
        errorOccurred = true;
      }
      // Clamp the value after checking for errors
      value = Math.max(parseFloat(this.lengthInchesInput.min), Math.min(value, parseFloat(this.lengthInchesInput.max)));
      this.lengthInchesInput.value = value;
    }

    // Return true if any error occurred
    return errorOccurred;
  }

  validateMetric(input, value) {
    const min = input.name === 'customWidth' ? this.initialMinWidth : this.initialMinLength;
    const max = input.name === 'customWidth' ? this.initialMaxWidth : this.initialMaxLength;
    let errorOccurred = false;

    if (isNaN(value) || value < min || value > max) {
      errorOccurred = true;
    }

    value = Math.floor(value);

    // Clamp the value after checking for errors
    if (isNaN(value) || value < min) {
      input.value = min;
    } else if (value > max) {
      input.value = max;
    } else {
      input.value = value; // Update the input field with the rounded value
    }

    return errorOccurred;
  }

  updatePrice() {
    let areaInSquareMeters;
    this.priceDisplay.classList.remove('error'); // Remove error class initially

    if (this.unitOfLength === 'inch') {
      // Use the clamped values from the input fields
      const lengthInInches =
        (parseFloat(this.lengthFeetInput.value) || 0) * 12 + (parseFloat(this.lengthInchesInput.value) || 0);
      const widthInInches =
        (parseFloat(this.widthFeetInput.value) || 0) * 12 + (parseFloat(this.widthInchesInput.value) || 0);

      // Check for valid dimensions
      if (
        isNaN(lengthInInches) ||
        isNaN(widthInInches) ||
        lengthInInches < this.initialMinLength ||
        lengthInInches > this.initialMaxLength ||
        widthInInches < this.initialMinWidth ||
        widthInInches > this.initialMaxWidth ||
        this.hasError // Check if an error was flagged
      ) {
        /*
        if (this.hasAttemptedUpdate) {
          this.priceDisplay.textContent = window.customizerStrings.dimensions_error;
          this.priceDisplay.classList.add('error'); // Add error class
        }
        */
        return;
      }

      const lengthInMeters = lengthInInches * 0.0254; // Convert inches to meters
      const widthInMeters = widthInInches * 0.0254; // Convert inches to meters
      areaInSquareMeters = lengthInMeters * widthInMeters;
    } else {
      // Use the clamped values from the input fields
      const lengthInCm = parseFloat(this.lengthInput.value) || 0;
      const widthInCm = parseFloat(this.widthInput.value) || 0;

      // Check for valid dimensions in cm
      if (
        isNaN(lengthInCm) ||
        isNaN(widthInCm) ||
        lengthInCm < this.initialMinLength ||
        lengthInCm > this.initialMaxLength ||
        widthInCm < this.initialMinWidth ||
        widthInCm > this.initialMaxWidth ||
        this.hasError // Check if an error was flagged
      ) {
        /*
        if (this.hasAttemptedUpdate) {
          this.priceDisplay.textContent = window.customizerStrings.dimensions_error;
          this.priceDisplay.classList.add('error'); // Add error class
        }
        */
        return;
      }

      const lengthInMeters = lengthInCm / 100; // Convert cm to meters
      const widthInMeters = widthInCm / 100; // Convert cm to meters
      areaInSquareMeters = lengthInMeters * widthInMeters;
    }

    const totalPrice = this.basePrice + this.unitPrice * areaInSquareMeters;

    const priceContainer = document.querySelector('.custom_price_container');
      if (priceContainer && priceContainer.classList.contains('hidden')) {
        priceContainer.classList.remove('hidden');
      }

    this.priceDisplay.textContent = `: ${Woolman.Utils.formatMoney(totalPrice, null, true)}`;
    this.hasAttemptedUpdate = true; // Set the flag to true after the first attempt
  }

  onCustomDropdownClose() {
    if (!this.isDropdownOpen) return;

    this.isDropdownOpen = false;
    this.parentDropdown.reset();
    this.classList.remove('active');

    // Show the dropdown items again when form is closed
    if (this.parentDropdown && this.parentDropdown.itemsContainer) {
      this.parentDropdown.itemsContainer.style.display = '';
    }

    this.removeCustomSizeInputs();
  }

  removeCustomSizeInputs() {
    const customSizeInputs = this.form.querySelectorAll('input[class^="customizer-input"]');
    customSizeInputs.forEach(input => input.remove());
  }

  updateButtonState() {
    let lengthIsValid, widthIsValid;

    if (this.unitOfLength === 'inch') {
      const totalLengthInInches =
        (parseFloat(this.lengthFeetInput.value) || 0) * 12 + (parseFloat(this.lengthInchesInput.value) || 0);
      const totalWidthInInches =
        (parseFloat(this.widthFeetInput.value) || 0) * 12 + (parseFloat(this.widthInchesInput.value) || 0);

      lengthIsValid =
        !isNaN(totalLengthInInches) &&
        totalLengthInInches >= this.initialMinLength &&
        totalLengthInInches <= this.initialMaxLength;
      widthIsValid =
        !isNaN(totalWidthInInches) &&
        totalWidthInInches >= this.initialMinWidth &&
        totalWidthInInches <= this.initialMaxWidth;
    } else {
      lengthIsValid =
        !isNaN(parseFloat(this.lengthInput.value)) &&
        parseFloat(this.lengthInput.value) >= this.initialMinLength &&
        parseFloat(this.lengthInput.value) <= this.initialMaxLength;
      widthIsValid =
        !isNaN(parseFloat(this.widthInput.value)) &&
        parseFloat(this.widthInput.value) >= this.initialMinWidth &&
        parseFloat(this.widthInput.value) <= this.initialMaxWidth;
    }

    const shouldDisableButton = !(lengthIsValid && widthIsValid);

    if (this.clonedButton) {
      this.clonedButton.disabled = shouldDisableButton;
    }
  }
}

customElements.define('custom-size-form', CustomSizeForm);

class CustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.id = this.getAttribute('id');
    this.selectedValue = '';
    this.isOpen = false;
    this.placeholderString = this.getAttribute('placeholder') ?? 'Select option';

    this.button = this.querySelector('.custom-dropdown__button');
    this.itemsContainer = this.querySelector('.custom-dropdown__items');
    this.relatedSelect = document.getElementById(this.getAttribute('select-id'));
    this.original_form_button = document.querySelector('.product-form__submit');
    this.placeHolderAddToCart = this.original_form_button.innerHTML;
    this.closeForm = this.querySelector('.custom-size-close');
    this.customFormPDP_bg_close = this.querySelector('.custom-size-overlay');

    this.initSelectedValue();

    this.button.addEventListener('click', this.toggleDropdown.bind(this));
    this.button.addEventListener('keydown', this.handleButtonKeydown.bind(this));
    this.itemsContainer.addEventListener('keydown', this.handleItemsContainerKeydown.bind(this));
    this.itemsContainer.addEventListener('click', this.handleItemClick.bind(this));
    if (this.closeForm) {
      this.closeForm.addEventListener('click', this.closeCustomForm.bind(this));
    }
    if (this.customFormPDP_bg_close) {
      this.customFormPDP_bg_close.addEventListener('click', this.closeCustomForm.bind(this));
    }
  }

  closeCustomForm(event) {
    event.preventDefault();
    const customForm = this.closeForm.closest('.custom-size-form');
    if (customForm) {
      customForm.classList.remove('active');
      // Show the dropdown items again when form is closed
      if (this.itemsContainer) {
        this.itemsContainer.style.display = '';
      }
      this.closeDropdown();

    }
    //console.log("close form");
  }
  

  initSelectedValue() {
    if (this.relatedSelect) {
      const selectedOption = this.relatedSelect.querySelector('option[selected]');
      if (selectedOption) {
        const value = selectedOption.value;
        this.value = value;
      }
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.updateDropdownState();
  }

  closeDropdown() {
    this.isOpen = false;
    this.updateDropdownState();
    this.dispatchCloseEvent();
  }

  updateDropdownState() {
    this.itemsContainer.style.display = this.isOpen ? 'block' : 'none';
    this.button.setAttribute('aria-expanded', String(this.isOpen));
    this.itemsContainer.setAttribute('aria-hidden', String(!this.isOpen));
    this.classList.toggle('opened', this.isOpen);
    this.modal = this.closest('.modal-dialog');

    if (this.isOpen) {
      // Set the width and position of the dropdown to match the button (desktop only)
      const isInModal = this.closest('.modal');
      /*if (window.innerWidth >= 1024 && !isInModal) {
        const buttonRect = this.button.getBoundingClientRect();
        this.itemsContainer.style.width = `${buttonRect.width}px`;
        this.itemsContainer.style.left = `${buttonRect.left}px`;
      } else {
        // Reset inline styles for mobile
        this.itemsContainer.style.width = '';
        this.itemsContainer.style.left = '';
      }*/
      
      document.addEventListener('click', this.handleDocumentClick.bind(this));
      this.itemsContainer.focus();
      if (this.modal) {
        this.modal.style.height = this.modal.scrollHeight + 25 + 'px';
        //console.log(this.modal.scrollHeight);
      }
    } else {
      document.removeEventListener('click', this.handleDocumentClick.bind(this));
    }
  }

  handleButtonKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleDropdown();
    }
  }

  handleItemsContainerKeydown(event) {
    const currentIndex = Array.from(this.itemsContainer.children).indexOf(document.activeElement);

    if (event.key === 'ArrowUp' && currentIndex > 0) {
      event.preventDefault();
      this.itemsContainer.children[currentIndex - 1].focus();
    } else if (event.key === 'ArrowDown' && currentIndex < this.itemsContainer.children.length - 1) {
      event.preventDefault();
      this.itemsContainer.children[currentIndex + 1].focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.selectOption(document.activeElement);
    }
  }

  handleItemClick(event) {
    const option = event.target.closest('.custom-dropdown__item');
    if (option) {
      this.selectOption(option);
      this.updateNativeSelect(option);
      this.dispatchChangeEvent(option);
      if (this.modal) {
        this.customForm = document.querySelector('.custom-size-form');
        if (this.customForm && this.customForm.classList.contains('active')) {
          let customFormHeight = this.customForm.scrollHeight;
          this.modal.style.height = customFormHeight + 145 + 'px';
        }
      }
    }
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.closeDropdown();
      if (this.modal) {
        this.modal.style.height = '';

        if (this.original_form_button) {
          this.original_form_button.innerHTML = this.placeHolderAddToCart;
        }
      }
    }
  }

  dispatchChangeEvent(option) {
    const customEvent = new CustomEvent(`custom-dropdown--${this.id}:change`, {
      bubbles: true,
      detail: { option },
    });
    this.dispatchEvent(customEvent);
  }

  dispatchCloseEvent() {
    const customEvent = new CustomEvent(`custom-dropdown--${this.id}:close`, {
      bubbles: true,
    });
    this.dispatchEvent(customEvent);
  }

  selectOption(option) {
    this.selectedValue = option.dataset.value;
    this.button.innerHTML = option.querySelector('[data-option-html]')
      ? option.querySelector('[data-option-html]').innerHTML.trim()
      : option.innerHTML.trim();
    Array.from(this.itemsContainer.children).forEach(item => {
      item.setAttribute('aria-selected', 'false');
    });
    option.setAttribute('aria-selected', 'true');
    !option.hasAttribute('data-prevent-auto-closing') && this.closeDropdown();
    if (this.modal) {
      this.modal.style.height = '';
    }
  }

  updateNativeSelect(option = null, value = null) {
    if (this.relatedSelect) {
      this.relatedSelect.value = value ?? option?.getAttribute('data-value');
      const changeEvent = new Event('change', { bubbles: true });
      this.relatedSelect.dispatchEvent(changeEvent);
    }
  }

  reset() {
    this.updateNativeSelect(null, 'default');

    this.button.innerHTML = this.placeholderString;
    Array.from(this.itemsContainer.children).forEach(item => {
      item.setAttribute('aria-selected', 'false');
    });
  }

  get value() {
    return this.selectedValue;
  }

  set value(newValue) {
    const option = this.itemsContainer.querySelector(`[data-value="${newValue}"]`);
    if (option) {
      this.selectOption(option);
      this.dispatchChangeEvent(option);
    }
  }
}

customElements.define('custom-dropdown', CustomDropdown);

